import { Button, ButtonProps } from '../02-atoms/Button';

export interface InPageNavigationProps {
  /** Navigation objects */
  items?: ButtonProps[];
  /** Additional class */
  className?: string;
}

/** In page navigation */
export const InPageNavigation = ({
  items,
  className,
  ...props
}: InPageNavigationProps) => {
  if (!items || items.length === 0) {
    return null;
  }
  return (
    <nav className={['in-page-navigation', className].join(' ')} {...props}>
      <ul className="in-page-navigation__items">
        {items?.map((item, i) => {
          return (
            <li key={i} className="in-page-navigation__item">
              <Button type="tertiary" size="large" {...item} />
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
